import { defineComponent, Ref, toRefs } from 'vue';
import Breadcrumb from './Breadcrumb.class';
import { IBreadcrumb } from '@/study-search/interfaces/breadcrumb.interface';
export default defineComponent({
	props:{
		breadcrumb: {
			type: Object,
			required: true
		},
	},
	setup: (props) => {
		const {breadcrumb} = toRefs(props);
		const component = new Breadcrumb(breadcrumb as Ref<IBreadcrumb>);
		component.onBreadcrumbClick = component.onBreadcrumbClick.bind(component);
		return {
			...component,
		};
	}
})